import { Entity, SelectionSystem } from '@aninix-inc/model'

export const isLayerSelected = (layer: Entity): boolean => {
  const selection = layer.getProjectOrThrow().getSystemOrThrow(SelectionSystem)
  return selection.isSelected(layer.id)
}
